
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/linear/command","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#0079f2"}},[_c('path',{attrs:{"d":"M8.064 7.064h7.871a1 1 0 011 1v7.871a1 1 0 01-1 1H8.064a1 1 0 01-1-1V8.064a1 1 0 011-1zm6.871 2H9.064v5.871h5.871z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.079 23.032a3.956 3.956 0 01-3.95-3.953v-2.95a1 1 0 011-1h2.95a3.952 3.952 0 010 7.9zm-1.95-5.903v1.95a1.952 1.952 0 101.95-1.95zM19.079 8.871h-2.95a1 1 0 01-1-1V4.918a3.952 3.952 0 113.95 3.953zm-1.952-2h1.952a1.952 1.952 0 10-1.95-1.953zM7.871 8.871H4.918a3.952 3.952 0 113.953-3.953v2.953a1 1 0 01-1 1zM4.918 2.968a1.952 1.952 0 100 3.9h1.953v-1.95a1.954 1.954 0 00-1.953-1.95zM4.918 23.032a3.952 3.952 0 010-7.9h2.953a1 1 0 011 1v2.947a3.956 3.956 0 01-3.953 3.953zm0-5.9a1.952 1.952 0 101.953 1.947v-1.95z"}})])])
          )
        }
      }
    